module.exports = __webpack_public_path__ + "img/copy.3aae4510.png";